import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = ["content"]
const _hoisted_5 = ["content"]
const _hoisted_6 = ["content"]
const _hoisted_7 = ["content"]
const _hoisted_8 = ["content"]
const _hoisted_9 = ["content"]
const _hoisted_10 = ["content"]
const _hoisted_11 = ["content"]
const _hoisted_12 = ["content"]
const _hoisted_13 = ["content"]
const _hoisted_14 = ["content"]
const _hoisted_15 = ["content"]
const _hoisted_16 = ["content"]
const _hoisted_17 = ["content"]
const _hoisted_18 = ["content"]
const _hoisted_19 = ["content"]
const _hoisted_20 = ["content"]

import { IonApp, IonRouterOutlet, IonPage, modalController } from "@ionic/vue"
  import { computed, onMounted, watch, nextTick } from "vue"
  import { useRoute } from "vue-router"
  import { useMetadataStore } from "@/store/metadata"
  import { useTokenStore } from "@/store/token"
  import { useUserStore } from "@/store/user"
  import { useAccountStore } from "@/store/account"
  import ModalContainer from "@/components/workbean-page/ModalContainer.vue"
  import MigrateHeader from "@/components/migrateBanner.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const metadata = computed(() => useMetadataStore().details)
  const token = computed(() => useTokenStore().activeToken)
  const route = useRoute()
  const status = computed(() => useAccountStore().status)

  const retrieveCustomer = async () => {
    if (token.value && token.value !== "" && token.value !== undefined && !useAccountStore().retrieved) {
      await useAccountStore().retrieveCustomerAccount()
    }
  }

  const redirection = (status: string) => {
    if (status === "for activation" && route.path !== "/verify") window.location.href = "/verify"
    else if (status !== "for activation" && route.path === "/verify") window.location.href = "/workbean-world"
    else if (status === "active" && !useAccountStore().onboarding_completion && route.fullPath !== "/details") {
      window.location.href = "/details"
    }
  }

  const domain = computed(() => new URL(window.location.href).hostname)
  // check if uses mobile or not
  if (
    !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !route.fullPath.includes("/company/"))
  ) {
    window.location.href = "https://www.workbean.co/"
  }

  onMounted(async () => {
    if (useAccountStore().retrieved) redirection(useAccountStore().status)
    nextTick(() => {
      if (token.value) retrieveCustomer()
    })
    /**
     * create page to modal
     */
    const modal = modalController.create({
      component: ModalContainer,
      initialBreakpoint: 0.5,
      breakpoints: [0.5, 1.0],
      backdropDismiss: false,
    })
    if (route.fullPath.includes("/workbean-world/employee-ambassadorship/") || (route.fullPath.includes("/workbean-world/thought-leadership/") && route.params.id)) {
      route.params.id ? (await modal).present() : (await modal).dismiss()
    }
    if (route.meta.details) useMetadataStore().details = { ...metadata.value, ...route.meta.details }
  })

  watch(
    () => token.value,
    () => {
      retrieveCustomer()
    }
  )

  watch(
    () => route.fullPath,
    () => {
      useMetadataStore().domain = domain.value
    }
  )

  /**
   * Watches the flag 'retrieved' if user account details were retrieved
   * and redirects user to right pagesif user is done with onboarding
   */
  watch(
    () => useAccountStore().retrieved,
    (val) => {
      if (val) {
        if (val) redirection(useAccountStore().status)
      }
    }
  )

  watch(
    () => status.value,
    (val) => {
      if (val === "active") {
        useUserStore().retrieveCustomerDetails()
      }
    }
  )

  watch(
    () => route,
    async (value) => {
      if (value.fullPath.includes("/workbean-world/employee-ambassadorship/") || (value.fullPath.includes("/workbean-world/thought-leadership/") && value.params.id)) {
        /**
         * create page to modal
         */
        const modal = modalController.create({
          component: ModalContainer,
          initialBreakpoint: 0.5,
          breakpoints: [0.5, 1.0],
          backdropDismiss: false,
        })
        ;(await modal).present()
      }
    },
    { deep: true }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createElementVNode("title", null, _toDisplayString(metadata.value.title), 1),
      _createElementVNode("link", {
        rel: "canonical",
        href: metadata.value.og.canonical
      }, null, 8, _hoisted_1),
      _createElementVNode("meta", {
        property: "description",
        content: metadata.value.description
      }, null, 8, _hoisted_2),
      _createElementVNode("meta", {
        property: "robots",
        content: metadata.value.robots
      }, null, 8, _hoisted_3),
      _createElementVNode("meta", {
        property: "og:title",
        content: metadata.value.og.title
      }, null, 8, _hoisted_4),
      _createElementVNode("meta", {
        property: "og:type",
        content: metadata.value.og.type
      }, null, 8, _hoisted_5),
      _createElementVNode("meta", {
        property: "og:description",
        content: metadata.value.og.description
      }, null, 8, _hoisted_6),
      _createElementVNode("meta", {
        property: "og:image",
        content: metadata.value.og.image
      }, null, 8, _hoisted_7),
      _createElementVNode("meta", {
        property: "og:url",
        content: metadata.value.og.url
      }, null, 8, _hoisted_8),
      _createElementVNode("meta", {
        property: "og:site_name",
        content: metadata.value.og.site_name
      }, null, 8, _hoisted_9),
      _createElementVNode("meta", {
        property: "twitter:title",
        content: metadata.value.twitter.title
      }, null, 8, _hoisted_10),
      _createElementVNode("meta", {
        property: "twitter:description",
        content: metadata.value.twitter.description
      }, null, 8, _hoisted_11),
      _createElementVNode("meta", {
        property: "twitter:image",
        content: metadata.value.twitter.image
      }, null, 8, _hoisted_12),
      _createElementVNode("meta", {
        property: "twitter:site",
        content: metadata.value.twitter.site
      }, null, 8, _hoisted_13),
      _createElementVNode("meta", {
        property: "twitter:creator",
        content: metadata.value.twitter.creator
      }, null, 8, _hoisted_14),
      (metadata.value.og.type === 'profile')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("meta", {
              property: "og:first_name",
              content: metadata.value.og.first_name
            }, null, 8, _hoisted_15),
            _createElementVNode("meta", {
              property: "og:last_name",
              content: metadata.value.og.last_name
            }, null, 8, _hoisted_16)
          ], 64))
        : _createCommentVNode("", true),
      (metadata.value.og.type === 'article')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("meta", {
              property: "og:author",
              content: metadata.value.og.author
            }, null, 8, _hoisted_17),
            _createElementVNode("meta", {
              property: "og:published_time",
              content: metadata.value.og.published_time
            }, null, 8, _hoisted_18),
            _createElementVNode("meta", {
              property: "og:modified_time",
              content: metadata.value.og.modified_time
            }, null, 8, _hoisted_19),
            _createElementVNode("meta", {
              property: "og:section",
              content: metadata.value.og.section
            }, null, 8, _hoisted_20)
          ], 64))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_unref(IonApp), null, {
      default: _withCtx(() => [
        _createVNode(MigrateHeader),
        _createVNode(_unref(IonRouterOutlet), null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_unref(IonPage), null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { class: "text-primary-black" })),
                _createTextVNode(" /> ")
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})